import { atom, selector } from "recoil";
import { v1 } from "uuid";

export const profileIdState = atom<string | null>({
  key: `profileIdState/${v1()}`,
  default: null,
});

export const profileIdStateSelector = selector({
  key: `profileIdSelector/${v1()}`,
  get: ({ get }) => {
    return get(profileIdState);
  },
  set: ({ set }, profileId) => {
    set(profileIdState, profileId);
  },
});
